import { Fragment } from "react";
import "./Styles.css";

const Loader = ({
    centered = true,
    width,
    height,
    color,
    size = "medium", // "small", "medium", "large"
    text = "",
    overlay = false,
}) => {
    const containerStyles = {};
    if (width) containerStyles.width = width;
    if (height) containerStyles.height = height;

    const sizeClass = `loader-${size}`;
    const spinnerColor = color || "var(--primaryColor)";

    return (
        <Fragment>
            <div className={`loaderContainer ${centered ? "centered" : "inline"} ${overlay ? "with-overlay" : ""}`} style={containerStyles}>
                <div className={`modern-loader ${sizeClass}`}>
                    <div className="loader-spinner">
                        <svg className="loader-circular" viewBox="25 25 50 50">
                            <circle
                                className="loader-path"
                                cx="50"
                                cy="50"
                                r="20"
                                fill="none"
                                strokeWidth="3"
                                style={{ stroke: spinnerColor }}
                            />
                        </svg>
                        <div className="loader-pulse" style={{ borderColor: spinnerColor }}></div>
                    </div>
                    {text && <p className="loader-text">{text}</p>}
                </div>
            </div>
        </Fragment>
    );
};

export default Loader;
